import { FC } from 'react';
import cx from 'classnames';

import { EventUserSchema, LiveEventAction } from 'types';
import { choosePaletteColor, getUserInitials } from 'utils';
import { useLiveEventActions } from 'hooks';
import { useLiveEvent } from 'containers/LiveEvent';
import { Avatar } from 'components';
import { CheckedIcon, CloseNewIcon, StarIcon } from 'components/Icon';

import styles from './HandRaises.Request.module.scss';

export type RequestProps = {
  user: EventUserSchema;
  onApprove?(username: string): void;
  onReject?(username: string): void;
};

const Request: FC<RequestProps> = ({ user, onApprove, onReject }) => {
  const liveEvent = useLiveEvent();
  const liveEventActions = useLiveEventActions(liveEvent.eventCode);

  const handleOnApprove = () => {
    if (!user) return;

    onApprove?.(user.username);
  };

  const handleOnReject = () => {
    if (!user) return;

    onReject?.(user.username);
  };

  const renderRejectButton = () => {
    const hasPermission = liveEventActions.hasPermission(LiveEventAction.REJECT_HAND_RAISE_REQUEST);

    if (hasPermission) {
      return (
        <button type="button" className={cx(styles.action, styles.reject)} onClick={handleOnReject}>
          <CloseNewIcon />
        </button>
      );
    }

    return null;
  };

  const renderApproveButton = () => {
    const hasPermission = liveEventActions.hasPermission(LiveEventAction.APPROVE_HAND_RAISE_REQUEST);

    if (hasPermission) {
      return (
        <button type="button" className={cx(styles.action, styles.approve)} onClick={handleOnApprove}>
          <CheckedIcon />
        </button>
      );
    }

    return null;
  };

  return (
    <div className={styles.container}>
      <div className={styles.info}>
        <div className={styles.avatar}>
          <Avatar
            src={user.avatar}
            initials={getUserInitials(user.name)}
            fallbackColor={choosePaletteColor(user.name)}
          />
          {user.member && (
            <div className={styles.badge}>
              <StarIcon />
            </div>
          )}
        </div>
        <span className={styles.name}>{user?.name}</span>
      </div>
      <div className={styles.actions}>
        {renderRejectButton()}
        {renderApproveButton()}
      </div>
    </div>
  );
};

export default Request;
